import { eponaQuery } from '@/helpers/graphql_modules/epona';
import { getDisciplinesForumChannel } from '@/store/queries/pegasus-epona.queries';
import { ChannelModel } from '@/models/forumAPI/ChannelModel';

interface DisciplinesIdsForumChannel {
  disciplineId: string;
  disciplineInstanceId?: string;
}

export class DisciplinesForumChannelsService {
  static async getDisciplinesForumChannels(
    courseId: string,
    disciplines: DisciplinesIdsForumChannel[],
  ): Promise<ChannelModel[]> {
    const {
      data: { getDisciplinesForumChannels },
    } = await eponaQuery(getDisciplinesForumChannel, {
      courseId,
      disciplines,
    });

    return getDisciplinesForumChannels.data;
  }
}
